import React from 'react';
import { withRouter } from 'react-router-dom';
import AuthUserContext from './context';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

type WithAuthorizationProps = {
    history: any,
    firebase: any
}

const withAuthorization = (condition: any) => (Component: any) => {
    class WithAuthorization extends React.Component<WithAuthorizationProps> {
        listener: any;
        componentDidMount() {
            this.listener = this.props.firebase.onAuthUserListener(
                (authUser: any) => {
                    if (!condition(authUser)) {
                        this.props.history.push(ROUTES.SIGN_IN);
                    }
                },
                () => this.props.history.push(ROUTES.SIGN_IN),
            );
        }
        componentWillUnmount() {
            this.listener();
        }
        render() {
            return (
                <AuthUserContext.Consumer>
                    {authUser =>
                        condition(authUser) ? <Component {...this.props} /> : null
                    }
                </AuthUserContext.Consumer>
            );
        }
    }
    return withRouter(withFirebase(WithAuthorization))

};
export default withAuthorization;